const searchMaskConfig = (window as any).aeroitaliaSearchMaskConfig;

if(searchMaskConfig?.publicPath) {
    __webpack_public_path__ = searchMaskConfig.publicPath;
}

export {};